import { deleteRest, get, post, put } from 'utils/rxfetch'
import { buildURL } from 'utils/urls'

export default () => ({
  add(companyId = '', body) {
    return post(`/members-api/mailboxes?companyFilter=${companyId}`, body)
  },
  get(
    page,
    sortProperty,
    typeFilter = 'all',
    protectedFilter = 'all',
    tagsFilter,
    segmentsFilter,
    riskLevelsFilter,
    search,
    companyFilter = '',
    perPage
  ) {
    return get(
      buildURL('/members-api/mailboxes', {
        page,
        sortProperty,
        typeFilter,
        protectedFilter,
        tagsFilter,
        segmentsFilter,
        riskLevelsFilter,
        search,
        companyFilter,
        perPage,
      })
    )
  },
  getEmails(companyFilter = '', search = '', includeMspUsers = false, page = 1, pageSize = 50) {
    return get(
      buildURL('/members-api/mailboxes/share', {
        companyFilter,
        search,
        page,
        pageSize,
        includeMspUsers,
      })
    )
  },
  getInfo(companyId = '') {
    return get(`/members-api/mailboxes/info?companyFilter=${companyId}`)
  },
  // source: tags type (titles, departments, etc.)
  // source = reduced --> all tags excluding titles and departments
  getTags({
    companyId = '',
    allTags = true,
    source = 'all',
    page = 1,
    search = '',
    onlyAutoTags,
    searchByTagIds,
  }) {
    return get(
      buildURL('/members-api/profiles/tags', {
        auto: 'true',
        companyFilter: companyId,
        allTags,
        source,
        pageNumber: page,
        search,
        onlyAutoTags,
        searchByTagIds,
      })
    )
  },
  getTagsToModify({
    companyId = '',
    profileIds = null,
    mode = null,
    page = 1,
    search = '',
    allTags = false,
    allProfiles = false,
  }) {
    return put(
      buildURL('/members-api/profiles/tags', {
        auto: 'true',
        companyFilter: companyId,
        mode,
        pageNumber: page,
        search,
        allTags,
      }),
      { profileIds, allProfiles }
    )
  },
  getSegments(companyId = '') {
    return get(`/members-api/profiles/segments?companyFilter=${companyId}`)
  },
  getTagsAndSegments({ companyId = '', page = 1, search = '' }) {
    return get(
      `/members-api/profiles/segments-tags?companyFilter=${companyId}&pageNumber=${page}&search=${search}`
    )
  },
  addSegment(companyId = '', body) {
    return post(`/members-api/profiles/segments?companyFilter=${companyId}`, body)
  },
  updateSegment(companyId = '', body) {
    return put(`/members-api/profiles/segments?companyFilter=${companyId}`, body)
  },
  deleteSegments(companyId = '', body) {
    return deleteRest(`/members-api/profiles/segments?companyFilter=${companyId}`, body, {
      'Content-Type': 'application/json',
    })
  },
  toggleStatus(companyId = '', id, status) {
    return put(`/members-api/mailboxes/${id}?companyFilter=${companyId}`, { active: status })
  },
  toggleStatuses(companyId = '', body) {
    return put(`/members-api/mailboxes?companyFilter=${companyId}`, body)
  },

  assignTags(companyId = '', body) {
    return post(`/members-api/profiles/tags?companyFilter=${companyId}`, body)
  },
  removeTags(companyId = '', body) {
    return deleteRest(`/members-api/profiles/tags?companyFilter=${companyId}`, body, {
      'Content-Type': 'application/json',
    })
  },
  disableAutoSync(companyId = '') {
    return deleteRest(
      `/members-api/profiles/autosync?companyFilter=${companyId}`,
      {},
      {
        'Content-Type': 'application/json',
      }
    )
  },
  asO365(companyId = '', body) {
    return post(`/members-api/profiles/autosync/o365?companyFilter=${companyId}`, body)
  },
  asGD(companyId = '', body) {
    return post(`/members-api/profiles/autosync/gmail?companyFilter=${companyId}`, body)
  },
  getUserReportData(companyId = '', id) {
    return get(`/members-api/mailboxes/user-report/${id}?companyFilter=${companyId}`)
  },
  getCustomizedAutoSyncData(companyId = '', integrationType, query, gdAdminEmail, page) {
    return get(
      buildURL('/members-api/profiles/autosync/o365/customized', {
        integrationType,
        query,
        gdAdminEmail,
        companyFilter: companyId,
        page,
      })
    )
  },
  updateCustomizedAutoSyncData(companyId = '', body) {
    return post(`/members-api/profiles/autosync/o365/customized?companyFilter=${companyId}`, body)
  },
  getVipUsersData(companyId = '') {
    return get(`/members-api/mailboxes/vip-users?companyFilter=${companyId}`)
  },
  updateVipUsersData(companyId = '', body) {
    return post(`/members-api/mailboxes/add-vip-user-tag?companyFilter=${companyId}`, body)
  },
  createComplianceReport(companyId = '', body) {
    return post(`/members-api/reports/compliance?companyFilter=${companyId}`, body)
  },
})
